import { LoadingButton } from "@mui/lab";
import { Button } from "@mui/material";
import React, { Component } from "react";

const AppButton = ({
  text,
  icon,
  variant,
  onClick,
  display,
  to,
  sx,
  style,
  size,
  color,
  type,
  component,
  title,
  loading = false,
  disabled = false,
}) => {
  return (
    <LoadingButton
      sx={{ ...sx}}
      loading={loading}
      type={type || "button"}
      size={size || "small"}
      title={title || ""}
      variant={variant || "text"}
      color={color || "primary"}
      startIcon={icon || null}
      onClick={onClick}
      style={{ ...style, fontWeight: 600, borderRadius: 1 }}
      component={component}
      to={to}
      disabled={disabled}
    >
      {text}
    </LoadingButton>
  );
};

export default AppButton;
